import { Users } from "lucide-react";
import CreditModule from "@/components/CreditModule";

export default function KasbonPelanggan() {
  return <CreditModule type="customer" icon={Users} />;
}
